export default __webpack_public_path__ + "static/media/BeforePhoto11.121f840d.jpg";